import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
// import AWS from 'aws-sdk';
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import PropTypes from 'prop-types';

import Swal from 'sweetalert2';
import {

  MenuItem,

} from '@mui/material';

const StockFollowUp = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  // const [dataa, setDataa] = useState([]);
  const [datagroupby, setDatagroupby] = useState([]);
  const [datagroupbySupplier, setDatagroupbySupplier] = useState([]);
  const [permission, setPermission] = useState({});
    let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(151)); 
        console.log(permission);
    let para ={season_id:season_id};
    axios.post("/stock-follow-ups/listing",para,{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
        setData(response.data.data.stocks);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });


      axios.post("/stock-follow-ups/listing-groupby-comsumble-location",para,{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
        setDatagroupby(response.data.data.stocks_groupby);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
      axios.post("/stock-follow-ups/listing-groupby-supplier-location",para,{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
        setDatagroupbySupplier(response.data.data.stocks_groupby_suppliers);
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  
  const deleteItem = (item) => {

    Swal.fire({
      title: 'Do you really want to delete this record?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/stock-follow-ups/delete/${season_id+'-'+item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/stock-situations";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });
  }
  
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };



// ✅ Reusable Link Cell Component - Consumable
const ConsumableLinkCell = ({ row }) => {
  const url = `/stock-situations-viewby-consumable-location/${row.original.consumable}_${row.original.location}`;
  return (
    <a href={url} className="">
      {row.original.consomable_name || ''}
    </a>
  );
};

// ✅ Reusable Link Cell Component - Location
const LocationLinkCell = ({ row }) => {
  const url = `/stock-situations-viewby-consumable-location/${row.original.consumable}_${row.original.location}`;
  return (
    <a href={url} className="">
      {row.original.location_name || ''}
    </a>
  );
};

// ✅ Available Quantity Cell Component
const AvailableQuantityCell = ({ row }) => {
  return (
    <span>
      {row.original.total_in_quantity - (row.original.total_out_quantity = row.original.product_out_final_quantity)}
    </span>
  );
};

const AvailableAlertQuantityCell = ({ row }) => {
  const available_qty = row.original.avail_quantity; 
   
  
  const critical_level = row.original.consomable_critical_level || 0;

  const average_level = row.original.consomable_average_level || 0;
  let alert_qty = null;
  
  console.log(critical_level);
  console.log(average_level);
   if (available_qty < critical_level) {
    alert_qty = (
      <span style={{ color: 'red', fontWeight: 'bold' }}>
        CRITICAL LEVEL
      </span>
    );
  }else if ( available_qty >= critical_level && available_qty <= average_level) {
    alert_qty = (
      <span style={{ color: 'orange', fontWeight: 'bold' }}>
        AVERAGE LEVEL
      </span>
    );
  } else{
    alert_qty = (
      <span style={{ color: 'orange', fontWeight: 'bold' }}> </span>
    );
  }
  return <div>{alert_qty}</div>;
};
AvailableAlertQuantityCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      total_in_quantity: PropTypes.number.isRequired,
      avail_quantity:PropTypes.number.isRequired,
      total_out_quantity: PropTypes.number.isRequired,
      product_out_final_quantity: PropTypes.number.isRequired,
      consomable_average_level: PropTypes.number.isRequired,
      consomable_critical_level: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};


// ✅ PropTypes Validation
ConsumableLinkCell.propTypes = LocationLinkCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      consumable_name: PropTypes.string,
      location_name: PropTypes.string,
      consumable: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      location: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    }).isRequired,
  }).isRequired,
};

AvailableQuantityCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      total_in_quantity: PropTypes.number.isRequired,
      total_out_quantity: PropTypes.number.isRequired,
      product_out_final_quantity: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

// ✅ Columns Definition
const columnsss = [
  {
    header: 'Consumable',
    accessorFn: (row) => row.consomable_name,
        accessorKey: 'consomable_name',
    Cell: ConsumableLinkCell,
  },
  {
    header: 'Location',
    accessorFn: (row) => row.location_name,
    Cell: LocationLinkCell,
  },
  // {
  //   header: 'Available Quantity',
  //   accessorFn: (row) => row.total_in_quantity - (row.total_out_quantity + row.product_out_final_quantity),
  //   Cell: AvailableQuantityCell,
  // },
    {
    header: 'Available Quantity',
    accessorKey: 'avail_quantity',
  },
  {
    header: 'Quantity Alert',
    //accessorFn: (row) => row.total_in_quantity - (row.total_out_quantity + row.product_out_final_quantity),
    Cell: AvailableAlertQuantityCell,
  },
];


// ✅ Reusable Link Cell Component
const ConsumableLinkCellSupplier = ({ row }) => {
  const url = `/stock-situations-viewby-supplier-location/${row.original.supplier}_${row.original.location}`;
  return (
    <a href={url} className="">
      {row.original.supplier_detail?.name || ''}
    </a>
  );
};

// ✅ Location Link Cell Component
const LocationLinkCellSupplier = ({ row }) => {
  const url = `/stock-situations-viewby-supplier-location/${row.original.supplier}_${row.original.location}`;
  return (
    <a href={url} className="">
      {row.original.location_name || ''}
    </a>
  );
};

// ✅ Available Quantity Cell Component
const AvailableQuantityCellSupplier = ({ row }) => {
  return (
    <span>
      {row.original.total_in_quantity - row.original.total_out_quantity}
    </span>
  );
};

// ✅ PropTypes Validation
ConsumableLinkCellSupplier.propTypes = LocationLinkCellSupplier.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      supplier_detail: PropTypes.shape({
        name: PropTypes.string,
      }),
      location_name: PropTypes.string,
      supplier: PropTypes.any.isRequired,
      location: PropTypes.any.isRequired,
    }).isRequired,
  }).isRequired,
};

AvailableQuantityCellSupplier.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      total_in_quantity: PropTypes.number.isRequired,
      total_out_quantity: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

// ✅ Columns Definition
const columns_supplier = [
  {
    header: 'Supplier',
    accessorFn: (row) => row.supplier_detail?.name,
    Cell: ConsumableLinkCellSupplier,
  },
  {
    header: 'Location',
    accessorFn: (row) => row.location_name,
    Cell: LocationLinkCellSupplier,
  },
  {
    header: 'Available Quantity',
    accessorFn: (row) => row.total_in_quantity - row.total_out_quantity,
    Cell: AvailableQuantityCellSupplier,
  },
];


  // ✅ Location Link Cell Component
const LocationLinkCell2 = ({ row }) => {
  const url = `/stock-situations-view/${row.original.id}`;
  return (
    <a href={url} className="">
      {row.original.location_detail?.title || ''}
    </a>
  );
};

// ✅ PropTypes Validation
LocationLinkCell2.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.any.isRequired,
      location_detail: PropTypes.shape({
        title: PropTypes.string,
      }),
    }).isRequired,
  }).isRequired,
};

// ✅ Columns Definition
const columns = [
  {
    header: 'Location',
    accessorFn: (row) => row.consumable,
    Cell: LocationLinkCell2,
  },
  {
    header: 'Date',
    accessorKey: 'date',
  },
  {
    header: 'Created',
    accessorKey: 'created_at',
  },
  {
    header: 'Created By',
    accessorFn: (row) =>
      row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}` : '',
  },
  {
    header: 'Updated By',
    accessorFn: (row) =>
      row.updatedby ? `${row.updatedby.first_name} ${row.updatedby.last_name}` : '',
  },
];


 

  const editItem = (item)=>{
    window.location.href = "/stock-situations-edit/"+item;
  }



  
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Stock Situation</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Stock Situation</li>
                </ul>
              </div>
              <div className="col-auto">
                
                 {permission && permission.add == 1 && (
                    <Link to="/stock-situations-add" className="btn btn-primary me-1">
                    <i className="fas fa-plus"></i>
                  </Link>
                )} 
              </div>
            </div>
          </div>
          <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                  {permission && permission.list == 1 && (

                    <div className="card-body">
                      <ul className="nav nav-tabs nav-tabs-bottom">
                      

                      <li className="nav-item">
                          <a className="nav-link active" href="#listing-groupby-supplier" data-bs-toggle="tab">Stock Situation Group By Consumable and Location</a>                                  
                      </li>
                      <li className="nav-item">
                          <a className="nav-link " href="#listing-customer" data-bs-toggle="tab"> Stock Situation Group By Supplier and Location</a>                                   
                      </li> 
                      <li className="nav-item">
                          <a className="nav-link " href="#listing-all" data-bs-toggle="tab"> Stock Situation  Listing</a>                                   
                      </li>                    
                      </ul>
                      <div className="tab-content">

                      <div className="tab-pane show active" id="listing-groupby-supplier">
                      <div className="row"   id="listing-followup">
                        <div className="col-sm-12">
                          <div className="card card-table">
                            <div className="card-body">
                                <div className="table-responsive">

                                <MaterialReactTable columns={columnsss} data={datagroupby} 
                                  enableColumnOrdering
                                  enablePinning
                                />
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                        
                        </div>                                
                        <div className="tab-pane  " id="listing-customer">
                              <div className="row"   id="listing-followup">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                        <MaterialReactTable columns={columns_supplier} data={datagroupbySupplier} 
                                          enableColumnOrdering
                                          enablePinning
                                        />
                                        
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                        
                        </div>                                
                                          
                        <div className="tab-pane  " id="listing-all">
                              <div className="row"   id="listing-followusp">
                                <div className="col-sm-12">
                                  <div className="card card-table">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                        <MaterialReactTable columns={columns} data={data} 
                                            enableColumnOrdering
                                            enablePinning
                                            enableRowActions
                                            //renderColumnActionsMenuItems 
                                            renderRowActionMenuItems={({ row }) => [
                                            permission?.update == 1 && (
                                              <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                                Edit
                                              </MenuItem>
                                            ),
                                            permission?.delete == 1 && (
                                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                                Delete
                                              </MenuItem>
                                            ),
                                          ]}
                                          />
                                        
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                        
                        </div>    
                      </div>                             
                    </div>
                    )}
                  </div>
              </div>
          </div>
        </div>
               
        </div>
      </div>
    </div>
  );
};
export default StockFollowUp;
